import ShopSection from './components/ShopSection'
import Header from './components/Header'
import Hero from './components/Hero'
import AboutSection from './components/AboutSection'
import NewsSection from './NewsSection'
import Footer from './components/Footer'
import SEO from './components/SEO'

function App() {
  return (
    <>
      <SEO 
        title="HelloWudang - Discover the Sacred Wudang Mountains"
        description="Your comprehensive guide to Wudang Mountains tourism, Taoist culture, martial arts, and travel experiences. Explore sacred sites, tai chi, and kung fu."
        keywords="Wudang, travel, tourism, Taoism, martial arts, tai chi, kung fu,武当,旅游,道教,武术,太极拳,功夫"
        type="website"
      />
      <div className="min-h-screen bg-gradient-to-b from-wudang-light to-white">
      <Header />
      <main>
        <Hero />
        <ShopSection />
        <AboutSection />
        <NewsSection website="hellowudang" title="Wudang Mountain News" themeColor="emerald" limit={10000} />
      </main>
      <Footer />
    </div>
    </>
  )
}

export default App